import * as THREE from 'three';
import {Texture} from "three";
import {PlaneBorder} from "./PlaneBorder";

export function Icon2D(type: string | null, id: string): THREE.Group {
    // Mapping entre le type et le chemin de la texture (ici des images PNG)
    const texturePaths: { [key: string]: string } = {
        directory: 'assets/three/TEXTURE/ICON_ANNUAIRE.png',
        application: 'assets/three/TEXTURE/ICON_APP.png',
        database: 'assets/three/TEXTURE/ICON_BDD.png',
        configuration: 'assets/three/TEXTURE/ICON_CONFIG.png',
        file: 'assets/three/TEXTURE/ICON_FICHIER.png',
        print: '../assets/three/TEXTURE/ICON_IMP.png',
        monitoring: 'assets/three/TEXTURE/ICON_MONITOR.png',
        mail: 'assets/three/TEXTURE/ICON_MSG.png',
        backup: 'assets/three/TEXTURE/ICON_SAVE.png',
        web: 'assets/three/TEXTURE/ICON_WEB.png',
        proxy: 'assets/three/TEXTURE/ICON_PROXY.png',
        security: 'assets/three/TEXTURE/ICON_SECU.png',
    };

    // Récupère le chemin de la texture correspondant au type fourni
    const texturePath: string = texturePaths[type || "application"];

    const width: number = 1;
    const height: number = 1;
    const radius: number = .3;
    const shape = new THREE.Shape();

    // Décalage pour centrer (x, y)
    const offsetX: number = -width / 2;
    const offsetY: number = -height / 2;

    shape.moveTo(offsetX + radius, offsetY);
    shape.lineTo(offsetX + width - radius, offsetY);
    shape.quadraticCurveTo(offsetX + width, offsetY, offsetX + width, offsetY + radius);
    shape.lineTo(offsetX + width, offsetY + height - radius);
    shape.quadraticCurveTo(offsetX + width, offsetY + height, offsetX + width - radius, offsetY + height);
    shape.lineTo(offsetX + radius, offsetY + height);
    shape.quadraticCurveTo(offsetX, offsetY + height, offsetX, offsetY + height - radius);
    shape.lineTo(offsetX, offsetY + radius);
    shape.quadraticCurveTo(offsetX, offsetY, offsetX + radius, offsetY);

    const geometry = new THREE.ShapeGeometry(shape);
    const planeBorder = PlaneBorder(width, height, radius, 0xB5B5C3, 0.01)
	planeBorder.userData.isOutline = true;
	planeBorder.userData.targetModelId = id;

    // // Création de la géométrie de la plane
    // const geometry = new THREE.PlaneGeometry(1.25, 1.25);

    // Chargement de la texture avec TextureLoader
    const textureLoader = new THREE.TextureLoader();
    const texture: Texture = textureLoader.load(
        texturePath,
        (): void => {
            // console.log(`Texture ${texturePath} chargée avec succès`);
            },
        undefined,
        (err: unknown): void => { console.error('Erreur lors du chargement de la texture', err); }
    );
    texture.offset.set(0.5, 0.5);

    // Création du matériau en appliquant la texture
    const material = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
    });

    // Création et retour du mesh
    const plane = new THREE.Mesh(geometry, material);
    plane.layers.set(1);
	plane.userData.id = id;
	plane.userData.outlineRef = planeBorder;
	plane.userData.modelType = "Server";

    const group: THREE.Group = new THREE.Group();
    group.add(plane, planeBorder);
    group.scale.set(1.25, 1.25, 1.25)
    group.rotation.x = -Math.PI / 2;
    group.visible = true;
    group.userData.type = "Icon";

    return group;
}
